<template>
  <div id="article">
    <div class="container">
      <section v-if="article">
        <div class="columns">
          <div class="column">
            <div class="box">
              <h2 class="title">{{ article.document.title }}</h2>
              <br>
              <small>{{ article.document.articleDate }}</small>
              <hr/>
              <rich-text :elements="article.document.content" :is-root="true" :has-style="true"></rich-text>
            </div>
            <figure class="image">
              <img :src="article.image" alt="">
            </figure>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import RichText from '@/components/RichText.vue';
import api from '@/services/api';

export default {
  name: 'news',
  components: {
    RichText,
  },
  data() {
    return {
      article: null,
    };
  },
  async created() {
    await this.fetchData();
  },
  watch: {
    $route: 'fetchData',
  },
  methods: {
    async fetchData() {
      this.article = await api.getArticle(this.$route.params.slug);
    },
    getImage(source) {
      return api.getImage(source);
    },
  },
};
</script>

<style lang="sass">
  #article
    .box
      padding: 2rem 1.5rem
      background: #ecf1f4
    img
      display: inline-block
      margin: 10px 0
      width: auto
    .rich-text
      .image
        text-align: center
</style>
